module.exports = __webpack_public_path__ + "static/media/profile-mia.5c5d89d6.jpg";